const hasNativePerformanceNow =
  typeof performance === "object" && typeof performance.now === "function";

export const now = hasNativePerformanceNow
  ? () => performance.now()
  : () => Date.now();
